import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { MovimientosConsulta } from "../entities/movimientos_entity";
import { AplicacionesTransporteResumen, AplicacionesConsulta, AplicacionEntityConsulta, AplicacionesMovimientos } from "../entities/aplicaciones_transporte_entity";
import { PolizaEntity } from "../entities/polizas_cliente_entity";

declare var jQuery: any;

@Injectable()
export class AplicacionesTransporteService {
    private userEmpresa: ClienteXCiudad;
    private url = "aplicaciones";

    constructor(private authHttp: AuthHttp, private http: Http, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    consultarAplicaciones(consulta: AplicacionesConsulta):Observable<AplicacionesTransporteResumen[]>{
        let body = JSON.stringify(consulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/resumenAplicaciones", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultarAplicacionesXPoliza(consulta: PolizaEntity):Observable<AplicacionesTransporteResumen[]>{
        let body = JSON.stringify(consulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/resumenAplicacionesXPoliza", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultarWebServiceUO(consultaAplicaicones: AplicacionEntityConsulta):Observable<any>{
        let body = JSON.stringify(consultaAplicaicones);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaAplicacionUO", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    AnularAplicacionTransporte(anularAplicacion: AplicacionesMovimientos):Observable<boolean>{
        let body = JSON.stringify(anularAplicacion);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/anularAplicacion", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultarUnidadAplicacionTransporte(cliente: ClienteXCiudad):Observable<number>{
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarUnidadAplicacionesTransporte", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultarPolizaAplicacionTransporte(cliente: ClienteXCiudad):Observable<any>{
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarPolizasAplicacionTransporte", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.service.ts